import { UserContext } from "../utils/UserContext";

export class DomainResolver {
  constructor(private client: any) {}

  async resolveDomain(
    userContext: UserContext,
    context: {
      linkedEntityId: string;
      linkedEntityType: "APPLICATION" | "GENUINE_STUDENT";
      institutionId?: string;
    },
  ): Promise<string> {
    if (userContext.isInstitutionOrAgent) {
      return userContext.userDomain!;
    }

    if (context.linkedEntityType === "APPLICATION") {
      const { data: application } = await this.client.models.Application.get(
        {
          institutionId: context.institutionId,
          applicationId: context.linkedEntityId,
        },
        { authMode: "userPool", authToken: userContext.token },
      );
      return application?.institutionId || userContext.userDomain || "";
    }

    const { data: genuineStudent } =
      await this.client.models.GenuineStudent.get(
        { genuineStudentId: context.linkedEntityId },
        { authMode: "userPool", authToken: userContext.token },
      );

    if (genuineStudent?.applicationId) {
      const { data: application } = await this.client.models.Application.get(
        { applicationId: genuineStudent.applicationId },
        { authMode: "userPool", authToken: userContext.token },
      );
      return application?.institutionId || userContext.userDomain || "";
    }

    return userContext.userDomain || "";
  }
}
